import { render, staticRenderFns } from "./resultsPage.vue?vue&type=template&id=6699651d&"
import script from "./resultsPage.ts?vue&type=script&lang=ts&"
export * from "./resultsPage.ts?vue&type=script&lang=ts&"
import style0 from "./resultsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports